<template>
  <ClientOnly>
    <Tooltip
      :placement="placement"
      :triggers="triggers"
      :distance="distance"
      :delay="delay"
      :theme="theme"
      class="inline-block"
    >
      <slot />
      <template #popper>
        <slot name="popper" />
      </template>
    </Tooltip>
    <template #fallback>
      <slot />
    </template>
  </ClientOnly>
</template>

<script setup>
import { Tooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

defineProps({
  placement: {
    type: String,
    default: 'top',
    validator: value =>
      [
        'top',
        'bottom',
        'left',
        'right',
        'top-start',
        'top-end',
        'bottom-start',
        'bottom-end',
        'left-start',
        'left-end',
        'right-start',
        'right-end',
      ].includes(value),
  },
  triggers: {
    type: Array,
    default: () => ['hover', 'focus'],
  },
  distance: {
    type: Number,
    default: 8,
  },
  delay: {
    type: Object,
    default: () => ({ show: 0, hide: 0 }),
  },
  theme: {
    type: String,
    default: 'tooltip',
  },
})
</script>
